/* unplugin-vue-components disabled */import script from "./Menu.vue?vue&type=script&setup=true&name=Menu&lang=js"
export * from "./Menu.vue?vue&type=script&setup=true&name=Menu&lang=js"

import "./Menu.vue?vue&type=style&index=0&id=5e203656&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e203656"]])

export default __exports__